




























































































































































import Button from '@/components/common/button.vue';
import Stamp from '@/components/stamp-module/stamp-item.vue';
import { useCouponTaskDialog } from '@/hooks/use-coupon-task-dialog';
import { useHalfTask } from '@/hooks/use-half-task';
import { i18n } from '@/i18n';
import { ExActAndConfigCouponInfo } from '@/types/coupon';
import { getSpCouponInfo, getValidPeriod, isMultiCoupon, isOnlineMerchantCoupon } from '@/utils';
import { biClick } from '@tencent/fit-bi-sdk';
import { FitHalfScreenDialog } from '@tencent/wphk-ui';
import { computed, defineComponent, PropType, ref } from '@vue/composition-api';
import { storeToRefs } from 'pinia';
import { language } from '@tencent/ppd-base-libs';
import { useGrayStore } from '@/store/gray';
import { CouponInfo, CouponType, CouponV2, parseCurrencyAria } from '@tencent/wphk-act-base-ui';
import SvgIcon from '@/components/common/svg-icon.vue';
import TncDialog from './tnc-dialog.vue';
import { useCouponDetailDialog } from '@/hooks/use-coupon-detail-dialog';
import { useCouponDetailSubscribe } from '@/hooks/use-coupon-detail-subscribe';
import SubscribeBtn from '@/components/subscribe-module/subscribe-btn.vue';
import { ExpireType } from '@tencent/wphk-act-base-cgi';
import dayjs from 'dayjs';

export default defineComponent({
  name: 'CouponInfoDialog',
  components: {
    HalfScreenDialog: FitHalfScreenDialog,
    Button,
    Stamp,
    CouponV2,
    SvgIcon,
    TncDialog,
    SubscribeBtn,
  },
  props: {
    /** 券信息 */
    couponInfo: {
      type: Object as PropType<ExActAndConfigCouponInfo>,
      required: true,
    },
    // 是否锁
    isLock: {
      type: Boolean,
      required: true,
    },
  },
  setup(prop, context) {
    // 语言
    const lang = ref(language.isEn() ? 'en' : 'zh-hk');
    const isLangEn = language.isEn();

    const { isGrayUser } = storeToRefs(useGrayStore());
    /** 关闭详情全局弹窗 */
    const { hideDialog: hideCouponDetailDialog } = useCouponTaskDialog();

    // 是否展示 tnc
    // @ts-ignore
    const isValidTnc = computed(() => prop.couponInfo.isSpCoupon && (prop.couponInfo.couponTandc || '').includes('tncId'));

    // 是否展示过期提示
    const isShowExpireTip = computed(() => {
      // 是否为固定时间类型
      const isFixedTime = prop.couponInfo.validExpireType === ExpireType.FIXED;
      // 当前时间
      const curTime = dayjs(prop.couponInfo.exSysTime || new Date());
      const exTime = dayjs(prop.couponInfo.expireTime);
      const isNear3Day = exTime.diff(curTime, 'day') <= 3 ;
      return isFixedTime && isNear3Day;
    });

    // tnc 弹窗
    const tncDialog = ref<InstanceType<typeof TncDialog> | null>(null);
    // 开启tnc弹窗
    function showTncDialog() {
      tncDialog.value?.showTncDialog();
    }

    const {
      isAllowExchangePrize,
      isShowTaskList,
      dialogBtnConfig,
      isDialogBtnDisabled,
      titleText,
      isShowCouponInfoDialog,
      showCouponInfoDialog,
      hideCouponInfoDialog,
    } = useCouponDetailDialog(prop);

    const {
      isShowSubcribe,
      isSubcribeInited,
    } = useCouponDetailSubscribe(isAllowExchangePrize, isDialogBtnDisabled, isShowCouponInfoDialog);

    // 还需多少印花无障碍提示文案
    const needStampAriaLabel = computed(() => {
      const { aboveTip } = dialogBtnConfig.value;
      if (aboveTip) {
        const { text, value } = aboveTip;
        let needStamp = i18n('{{count}}个印花', { count: value });
        if (language.isEn() && value <= 1) {
          needStamp = needStamp.replace('e-stamps', 'e-stamp') ;
        }
        return `${text} ${needStamp}`;
      }
      return '';
    });

    const biExt = computed(() => ({
      fcouponName: prop.couponInfo.couponName,
      fcouponId: prop.couponInfo.couponId,
      fsubscribe: isShowSubcribe.value ? '1' : '0',
    }));
    const isShowPerCount = computed(() => isMultiCoupon(prop.couponInfo));
    const validPeriod = computed(() => getValidPeriod(prop.couponInfo));

    // 是否是线上使用展示券
    const isOnlineMerchantCp = computed(() => isOnlineMerchantCoupon(prop.couponInfo));
    const spCouponUseScene = computed(() => (isOnlineMerchantCp.value ? i18n('於適用商戶網上商店/App支付時輸入推廣碼') : i18n('到店向店員出示使用')));

    const onClose = () => {
      biClick('rewards.rule_close', biExt.value);
      hideCouponInfoDialog();
      hideCouponDetailDialog();
      context.emit('onClose');
    };

    const couponCond = computed(() => {
      const { isSpCoupon, couponCond, requiredNum } = prop.couponInfo;
      return  isSpCoupon ? couponCond : i18n('消費滿HK$x可用', { requiredNum });
    });

    const couponCondAriaLabel = computed(() => parseAriaLabel(couponCond.value));

    /** 转换为无障碍提示文案（主要是对金额处理） */
    function parseAriaLabel(text: string) {
      const { currencyType } = prop.couponInfo as unknown as CouponInfo;
      return parseCurrencyAria(text, true, currencyType);
    }

    // 展示的券信息
    const dialogShowCouponInfo = computed(() => {
      const spCouponInfo = prop.couponInfo.isSpCoupon ? getSpCouponInfo() : {};
      const baseCouponInfo = prop.couponInfo.isDiscountCoupon ? {
        couponType: CouponType.discount,
        prizeDiscount: prop.couponInfo.discount,
      } : {
        couponType: CouponType.cash,
        prizeAmountYuan: prop.couponInfo.discount,
      };
      return {
        // 券基本信息
        prizeName: prop.couponInfo.couponName, // 优惠券名称
        pkgCount: (prop.couponInfo.perCount || 0) > 1 ? prop.couponInfo.perCount : 0, // 券包中券数量 / 一次派发张数
        ...spCouponInfo,
        ...baseCouponInfo,
        couponTagText: prop.couponInfo.couponTagText,
      };
    });

    return {
      dialogBtnConfig,
      isAllowExchangePrize,
      isShowTaskList,
      isOnlineMerchantCp,
      spCouponUseScene,
      isShowPerCount,
      validPeriod,
      isShowExpireTip,
      // 打开券详情弹窗
      showCouponInfo: showCouponInfoDialog,
      // 按钮点击
      onClickCloseDialog() {
        hideCouponInfoDialog();
        // 触发兑换
        if (isAllowExchangePrize.value) {
          context.emit('onExchPrize');
        } else if (isShowTaskList.value) {
        // 拉起任务弹框
          const halfTask = useHalfTask();
          halfTask.showHalfTask();
        }
      },
      titleText,
      onClose,
      parseAriaLabel,
      couponCond,
      couponCondAriaLabel,
      needStampAriaLabel,
      biExt,
      isLangEn,
      lang,
      isGrayUser,
      dialogShowCouponInfo,
      isValidTnc,
      tncDialog,
      isShowSubcribe,
      isSubcribeInited,
      isShowCouponInfoDialog,
      showTncDialog,
    };
  },
});
